import React from "react";
import { useApp } from "../../../state/Context";
import { SunIcon, MoonIcon } from "../../primatives/Icons";

export default function ThemeToggle() {
  const { theme, setTheme } = useApp();
  const next = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      className="
        inline-flex items-center gap-2 rounded-xl
        border border-neutral-300
        bg-white
        px-3 py-2
        text-sm font-medium text-neutral-800
        hover:bg-neutral-100
        dark:border-neutral-700
        dark:bg-neutral-900
        dark:text-neutral-200
        dark:hover:bg-neutral-800
      "
      aria-label="Toggle theme"
    >
      {theme === "dark" ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
